import Vue from 'vue'
import Vuex from 'vuex';
import VueI18nTreeNaics from "vue-i18n";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faMinus, faPlus, faInfoCircle, faCaretDown, faCaretUp, faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import store from "./store";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import ModalHome from "./components/ModalHome.vue";

Vue.use(Vuex);
Vue.use(VueI18nTreeNaics);
library.add(faSearch, faMinus, faPlus, faInfoCircle, faCaretDown, faCaretUp, faCaretLeft);
Vue.component('vue-fontawesome', FontAwesomeIcon);
Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas"
});

// Create VueI18n instance with options
export const i18n = new VueI18nTreeNaics({
  locale: "en"
});

const industryStorePlugin = {
  install (Vue, { store }) {
    store.registerModule('industryStorePlugin', store)
    Vue.component('open-services-tree-naics-lookup', OpenServicesTreeNaicsLookup)
  }
}
export {
  industryStorePlugin
}

// Global Mixin, use carefully !!
// What is added here is going to 
// run on every component
const mainBaseMixin = Vue.mixin({
  name: 'mainBaseMixin',
  store,
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    lang: {
      type: String,
      default: "en"
    },
    label: {
      type: String,
      default: ""
    },
    showCode: {
      type: Boolean,
      default: true
    },
    showResults:{
      type: String,
      default: ""
    },
    bpdata_itemselected: {
      type: Array,
      default: function () {
        return []
      }
    },
    selection: {
      type: Boolean,
      default: true
    }
  }, // end props
  data: function() {
    return {
      selectedItems: [],
      editNoSelection: true,
      examplesByNaics: {}
    }
  }, // end data
  computed: {
    ...mapGetters("industries", [
      "getAllSavedValues",
      "getAllCheckedValues",
      "getSearchHasResults",
      "getHasExampleByNaics",
      "getHasNoSelection",
      "getSavedTree",
      "getReducedTree",      
      "getSearchKeyword",
      "getInitTree",
      "getLevelSelectable",
      "getMapTopLevelNaics",
      "getAlgoliaHitsResult",
      "getAllIndustriesDirectus",
      "getShowDetail",
      "getNodeInfo"
    ]), // end mapGetters
    mx_toggleShowCode: function() {
      return this.showCode;
    },
    mx_toggleLang: function() {
      return this.lang;
    },
    mx_toggleMultiple: function() {
      return this.multiple;
    }
  }, // end computed
  methods: {
    ...mapMutations("industries", [
      "updateAllSaved",
      "updateAllChecked",
      "clearSaved",
      "clearSavedSelectTree",
      "updateHasResults",
      "updateExampleByNaics",
      "clearExampleByNaics",
      "updateHasNoSelection",
      "updateSavedTree",
      "updateReducedTree",      
      "updateSearchKeyword",
      "updateInitTree",
      "updateLevelSelectable",
      "updateMapTopLevelNaics",
      "updateAlgoliaHitsResult",
      "updateAllIndustriesDirecturs",
      "updateResultsTree",
      "clearResultsTree",
      "updateShowDetail",
      "clearSavedSelectTree",
      "updateSelectedNode"
    ]), // end mapMutations
    mx_isMobile: function() {
      if (screen.width <= 767) {
        return true;
      } else {
        return false;
      }
    }, // end mx_isMobile
    mx_homeModal: function() {
      this.$buefy.modal.open({
        parent: this,
        width: '90vw',
        props: {
          lang: this.mx_toggleLang,
          multiple: this.mx_toggleMultiple,
          bpdata_itemselected: this.selectedItems,
          selection: this.editNoSelection,
          showCode: this.mx_toggleShowCode
        },
        component: ModalHome,
        hasModalCard: false,
        canCancel: ["escape"],
        events: {
          'save': value => {     
            if (value.naics != null) {
              // for user to catch , follow same structure as naics code and name only, don't include examples
              let payload = {};
              payload.naics = value.naics.map(function(el) { return { code: el.code, name: el.name } })

              this.$emit("change", payload);
            }
          },
          'bpdata_selection': val => {
            this.updateHasNoSelection(val);
          }
        }
      });
    }, // end mx_homeModal
    mx_editInfo: function() {
      this.selectedItems = [];
      for (var item in this.getAllSavedValues.naics) {
        this.selectedItems.push(
          {
            id: this.getAllSavedValues.naics[item].code,
            text: this.getAllSavedValues.naics[item].name,
            examples: this.getAllSavedValues.naics[item].examples
          }
        );
      }

      this.editNoSelection = false;
      this.mx_homeModal();
    }, // end mx_editInfo
    mx_resetInfo: function() {
      // clear all
      this.updateAllSaved({
        key: "naics",
        payload: []
      });
      this.updateAllChecked({
        key: "naics",
        payload: []
      });      

      // reset Tree structute to inital state (i.e. full tree structure) 
      this.updateReducedTree(this.getInitTree);
      this.updateSavedTree(this.getInitTree);
      this.updateSearchKeyword("");

      let userPayload = { "naics": [] };
      this.$emit("change", userPayload);
      
      this.editNoSelection = true;
      this.updateHasNoSelection(true);
    }, // end mx_resetInfo
    mx_treeSelection: function(event) {
      this.updateHasNoSelection(event);
    } // end mx_treeSelection
  } // end methods
})

export default mainBaseMixin